'use strict';

require('../modules/forms/forms');
require('../helpers/show-modal-message/show-modal-message');

angular.module('far.forms.campDiscountForm', ['dekky.forms', 'far.helpers.showModalMessage'])
    .service('campDiscountForm', function (form, fileUploadFilters, showModalMessage) {
        var campDiscountModel = form('campDiscountModel');
        campDiscountModel
            .addField('name', null, {
                validators: {required: true},
                label: 'Название',
                options: {placeholder: ''}
            })
            .addField('link', null, {
                validators: {required: true},
                label: 'Ссылка (указывать с протоколом http://)',
                options: {placeholder: ''}
            })
            .addField('discount1', null, {
                validators: {required: false},
                label: 'Скдика членам ФАР',
                options: {placeholder: ''}
            })
            .addField('discount2', null, {
                validators: {required: false},
                label: 'Скдика жетонистам',
                options: {placeholder: ''}
            })
            .addField('discount3', null, {
                validators: {required: false},
                label: 'Скдика инструкторам',
                options: {placeholder: ''}
            })
            .addField('contacts', 'textarea', {
                label: 'Контакты',
                options: {
                    redactor: true,
                    placeholder: ''
                }
            });
        return campDiscountModel;
    });
